/* eslint-disable import/prefer-default-export */
import { useLocation } from 'react-router-dom';

export function useURLParam(param) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get(param);
}
